import { motion } from "framer-motion";
import imgRefcom from "@assets/image_1776020263717.png";
import imgFujitsu from "@assets/fujitsu-Logo-847-x-349_1793146431203.png";
import imgNiceic from "@assets/21851-NICEIC-Certified-Business-Anniversary-Logo-CPS-5Years-s_1776020570849.webp";
import imgDaikin from "@assets/DAIKIN_logo.svg_1793146297028.png";
import imgMitsubishi from "@assets/Mitsubishi_Electric_logo.svg_1793146297028.png";
import imgPanasonic from "@assets/Panasonic_logo_(Blue).svg_1793146297028.png";

const LOGOS = [
  { src: imgDaikin, alt: "Daikin" },
  { src: imgMitsubishi, alt: "Mitsubishi Electric" },
  { src: imgPanasonic, alt: "Panasonic" },
  { src: imgFujitsu, alt: "Fujitsu Air Conditioning" },
  { src: imgNiceic, alt: "NICEIC Registered Installer" },
  { src: imgRefcom, alt: "REFCOM F-Gas Certificated" },
];

export function Accreditations() {
  return (
    <section className="py-16 bg-background border-t border-border">
      <div className="container mx-auto px-4 max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-bold font-display text-center mb-4">Our Accreditations & Partners</h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">Certified by industry leaders and trusted by top manufacturers.</p>
        <div className="flex flex-wrap items-center justify-center gap-12 md:gap-16">
          {LOGOS.map((logo, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
            >
              <img src={logo.src} alt={logo.alt} className="h-16 md:h-20 w-auto max-w-[220px] object-contain grayscale hover:grayscale-0 transition-all duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
